export const TestId = {
  ACTION_BANNER_TEST_ID: 'action-banner-test-id'
};
